import React from "react";
import PropTypes from "prop-types";
import DetailLoader from "components/DetailLoader";
const DEFAULT_CLASSES = {
  container: "br2 pa2 hairline-1 shadow-0 ba bg-white mw-app center w-100"
};

const CardDetailLoader = ({ customClasses }) => {
  const classes = { ...DEFAULT_CLASSES, ...customClasses };
  return (
    <div className={classes.container}>
      <DetailLoader />
    </div>
  );
};

CardDetailLoader.propTypes = {
  customClasses: PropTypes.shape({
    container: PropTypes.string
  })
};

export default CardDetailLoader;
